"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.computeNumberOfVisibleChips = exports.useChipArray = void 0;
var lodash_1 = require("lodash");
var react_1 = require("react");
var miscHooks_1 = require("../../../hooks/miscHooks");
var ChipArray_static_1 = require("./ChipArray.static");
var ChipArray_style_1 = __importDefault(require("./ChipArray.style"));
function useChipArray(_a) {
    var alwaysExpanded = _a.alwaysExpanded, labels = _a.labels, maxChips = _a.maxChips, onDeleteChip = _a.onDeleteChip, preContent = _a.preContent;
    var classes = (0, ChipArray_style_1.default)();
    var containerRef = (0, react_1.useRef)(null);
    var _b = __read((0, react_1.useState)(false), 2), isExpanded = _b[0], setIsExpanded = _b[1];
    var _c = __read((0, react_1.useState)(), 2), visibleChipsState = _c[0], setVisibleChipsState = _c[1];
    (0, miscHooks_1.useWindowEventListener)('resize', (0, react_1.useCallback)(function () { return setVisibleChipsState(undefined); }, [setVisibleChipsState]), 200);
    (0, react_1.useLayoutEffect)(function () { return setVisibleChipsState(undefined); }, [preContent, labels, alwaysExpanded]);
    (0, react_1.useLayoutEffect)(function () {
        var container = containerRef.current;
        if (!visibleChipsState && container && !alwaysExpanded) {
            setVisibleChipsState(logic.computeNumberOfVisibleChips({
                container: container,
                preContent: container.getElementsByClassName(classes.preContent)[0],
                chips: container.getElementsByClassName(classes.chip),
                toggleButton: container.getElementsByClassName(classes.toggleButton)[0],
            }));
        }
    }, [classes.preContent, classes.chip, classes.toggleButton, alwaysExpanded, visibleChipsState]);
    var handleToggleButtonClick = function (event) {
        event.preventDefault();
        setIsExpanded(!isExpanded);
    };
    var _d = (function () {
        if (alwaysExpanded) {
            return { visibleLabels: labels, showToggleButton: false, isVisible: true };
        }
        if (!visibleChipsState) {
            return { visibleLabels: labels, showToggleButton: true, isVisible: false };
        }
        return {
            visibleLabels: isExpanded ? labels : labels.slice(0, visibleChipsState.numberOfChips),
            showToggleButton: !maxChips && visibleChipsState.numberOfChips < labels.length,
            isVisible: true,
        };
    })(), showToggleButton = _d.showToggleButton, visibleLabels = _d.visibleLabels, isVisible = _d.isVisible;
    return {
        classes: classes,
        containerRef: containerRef,
        handleDeleteChip: function (index) { return (onDeleteChip ? function () { return onDeleteChip(index); } : undefined); },
        handleToggleButtonClick: handleToggleButtonClick,
        isVisible: isVisible,
        numberMore: maxChips ? Math.max(0, labels.length - Math.min(maxChips, visibleLabels.length)) : 0,
        showToggleButton: showToggleButton,
        toggleButtonText: isExpanded ? ChipArray_static_1.localText.less : ChipArray_static_1.localText.more,
        visibleChipsState: visibleChipsState,
        visibleLabels: visibleLabels,
    };
}
exports.useChipArray = useChipArray;
function measureWidth(element, marginRight) {
    if (marginRight === void 0) { marginRight = 0; }
    return !element ? 0 : element.getBoundingClientRect().width + marginRight;
}
function computeNumberOfVisibleChips(_a) {
    var container = _a.container, preContent = _a.preContent, chips = _a.chips, toggleButton = _a.toggleButton;
    // Note: we always include the right margin in an element's width here.
    // To simplify calculations, we will assume that even the right-most chip/button has a margin-right.
    // To compensate, we increase the container's width by `chipItemMarginRight` in these calculations.
    var preContentWidth = measureWidth(preContent, ChipArray_static_1.preContentMarginRight);
    var chipWidths = (0, lodash_1.map)(chips, function (chip) { return measureWidth(chip, ChipArray_static_1.chipItemMarginRight); });
    var toggleButtonWidth = measureWidth(toggleButton, ChipArray_static_1.chipItemMarginRight);
    var totalWidth = measureWidth(container) + ChipArray_static_1.chipItemMarginRight;
    var allChipsWidth = (0, lodash_1.sum)(chipWidths);
    var lastChipWidth = (0, lodash_1.last)(chipWidths) || 0;
    var getMinChipWidth = function (index) { return Math.min(chipWidths[index], toggleButtonWidth); };
    if (!chipWidths.length || preContentWidth + allChipsWidth <= totalWidth) {
        return { numberOfChips: chipWidths.length, widthAvailableForLastChip: undefined };
    }
    var widthAvailableForLastChip = totalWidth - preContentWidth - allChipsWidth + lastChipWidth;
    if (widthAvailableForLastChip >= getMinChipWidth(chipWidths.length - 1)) {
        return {
            numberOfChips: chipWidths.length,
            widthAvailableForLastChip: widthAvailableForLastChip - ChipArray_static_1.chipItemMarginRight,
        };
    }
    var numberOfChips = 0;
    var availableWidth = totalWidth - preContentWidth - toggleButtonWidth;
    while (availableWidth >= getMinChipWidth(numberOfChips) && numberOfChips < chipWidths.length) {
        widthAvailableForLastChip = availableWidth;
        availableWidth -= chipWidths[numberOfChips];
        numberOfChips++;
    }
    return { numberOfChips: numberOfChips, widthAvailableForLastChip: widthAvailableForLastChip - ChipArray_static_1.chipItemMarginRight };
}
exports.computeNumberOfVisibleChips = computeNumberOfVisibleChips;
var logic = {
    useChipArray: useChipArray,
    computeNumberOfVisibleChips: computeNumberOfVisibleChips,
};
exports.default = logic;
